import { Injectable } from "@angular/core";
import * as moment from 'moment';

@Injectable()
export class DateUtil {

    dateToApiDateFormat(date: Date) : string {
        let day = date.getDate().toString().length > 1 ? date.getDate() : "0" + date.getDate();

        let dateMonth = date.getMonth() + 1;
        let month = dateMonth.toString().length > 1 ? dateMonth.toString() : ("0" + dateMonth.toString());

        return date.getFullYear() + "-" + month + "-" + day;
    }

    apiDateFormatToDate(date : string) : Date {
        return moment(date).toDate();
    }

    parseDateToStringYearMonthDay(date: Date) : string {
        let day = date.getDate().toString().length > 1 ? date.getDate() : "0" + date.getDate();
        let dateMonth = date.getMonth() + 1;
        let month = dateMonth.toString().length > 1 ? dateMonth.toString() : ("0" + dateMonth.toString());
        let fullYear = date.getFullYear();
        return fullYear + "-" + month  + "-" + day; 
    }

}